/**
 * Tipos de notificação que a pessoa pode receber (SPEC-20261103-1626).
 *
 * É o catálogo que a tela de preferências lista e que a API usa para dizer o
 * que está ligado. Tipo novo de notificação entra AQUI — e já nasce com o
 * e-mail ligado, porque a ausência de escolha gravada é "ligado".
 */
export const TIPOS_DE_NOTIFICACAO = [
  {
    kind: 'work_item_assigned',
    rotulo: 'Atribuição de Item de Trabalho',
    descricao: 'Quando alguém torna você responsável por um Item de Trabalho.',
  },
  {
    kind: 'calendar_invite',
    rotulo: 'Convite para evento',
    descricao: 'Quando alguém convida você para um evento do Calendário.',
  },
] as const

export type TipoDeNotificacao = (typeof TIPOS_DE_NOTIFICACAO)[number]['kind']

export const KINDS_DE_NOTIFICACAO = TIPOS_DE_NOTIFICACAO.map((t) => t.kind) as [
  TipoDeNotificacao,
  ...TipoDeNotificacao[],
]

/** A escolha da pessoa para um tipo. */
export type PreferenciaDeNotificacao = { kind: TipoDeNotificacao; email: boolean }

/**
 * As preferências completas, uma por tipo do catálogo: o que não foi gravado
 * vale como ligado. Escolha gravada de um tipo que saiu do catálogo é ignorada.
 */
export function preferenciasCompletas(
  gravadas: readonly { kind: string; email: boolean }[],
): PreferenciaDeNotificacao[] {
  return TIPOS_DE_NOTIFICACAO.map((t) => ({
    kind: t.kind,
    email: gravadas.find((g) => g.kind === t.kind)?.email ?? true,
  }))
}
